export { default } from './ProductStackNavigator';
export * from './ProductStackNavigator';
